import React, { useEffect, useState,memo } from 'react';
import userImg from '../../assets/images/userImg.png'
import logoWhite from '../../assets/images/logoWhite.png'
import { useLocation, useNavigate } from 'react-router-dom';
import Map from './Map';
import { getDailyClockInsCount, getDailyClockInsList, getNotClockedOutCount, getNotClockedOutList } from '../../apis/personnelApi';
import { fetchTodayDeviceCount } from '../../apis/deviceLogsApi';
import { toast } from 'react-toastify';
interface Tab {
    title: string | JSX.Element;
    route: string;
    activeIcon: JSX.Element;
    inactiveIcon: JSX.Element;
}

const Dashboard: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const userDataString = localStorage.getItem('userData');
    const userData = userDataString ? JSON.parse(userDataString) : null;

    const [selectedDate, setSelectedDate] = useState<string>(new Date().toISOString().split('T')[0]);
    const [dailyClockIns, setDailyClockIns] = useState<number | null>(null);
    const [dailyClockInsLoading, setDailyClockInsLoading] = useState<boolean>(false);
    const [dailyClockInsList, setDailyClockInsList] = useState<any[]>([]);
    const [showDetailsModal, setShowDetailsModal] = useState<boolean>(false);
    const [detailsLoading, setDetailsLoading] = useState<boolean>(false);

    const [notClockedOut, setNotClockedOut] = useState<number | null>(null);
    const [notClockedOutLoading, setNotClockedOutLoading] = useState<boolean>(false);
    const [notClockedOutList, setNotClockedOutList] = useState<any[]>([]);
    const [showNotClockedOutModal, setShowNotClockedOutModal] = useState<boolean>(false);
    const [notClockedOutDetailsLoading, setNotClockedOutDetailsLoading] = useState<boolean>(false);

    const [todayDevices, setTodayDevices] = useState<number | null>(null);
    const [todayDevicesLoading, setTodayDevicesLoading] = useState<boolean>(false);

    const handleNavigation = (route: string) => {
        if (route === 'daily-clockins') {
            fetchDailyClockInsDetails();
        } else if (route === 'not-clocked-out') {
            fetchNotClockedOutDetails();
        } else if (route === 'today-devices') {
            // Open Device Logs on today only
            navigate('/device-logs', { state: { today: true } });
        } else {
            navigate(route);
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('userData');
        navigate('/');
    };

    const fetchDailyClockIns = async (date: string) => {
        setDailyClockInsLoading(true);
        try {
            // convert date-only to datetime for the API as asked
           const count = await getDailyClockInsCount();
            setDailyClockIns(Number(count));
        } catch (error) {
            console.error('Failed to fetch daily clock-ins count:', error);
            setDailyClockIns(null);
            toast.error('Unable to fetch daily clock-ins count.');
        } finally {
            setDailyClockInsLoading(false);
        }
    };

    const fetchDailyClockInsDetails = async () => {
        setDetailsLoading(true);
        try {
            const list = await getDailyClockInsList();
            setDailyClockInsList(Array.isArray(list) ? list : []);
            setShowDetailsModal(true);
        } catch (error) {
            console.error('Failed to fetch daily clock-ins details:', error);
            toast.error('Unable to fetch daily clock-ins details.');
        } finally {
            setDetailsLoading(false);
        }
    };

    const fetchNotClockedOut = async () => {
        setNotClockedOutLoading(true);
        try {
            const count = await getNotClockedOutCount();
            setNotClockedOut(Number(count));
        } catch (error) {
            console.error('Failed to fetch not clocked out count:', error);
            setNotClockedOut(null);
            toast.error('Unable to fetch not clocked out count.');
        } finally {
            setNotClockedOutLoading(false);
        }
    };

    const fetchNotClockedOutDetails = async () => {
        setNotClockedOutDetailsLoading(true);
        try {
            const list = await getNotClockedOutList();
            setNotClockedOutList(Array.isArray(list) ? list : []);
            setShowNotClockedOutModal(true);
        } catch (error) {
            console.error('Failed to fetch not clocked out details:', error);
            toast.error('Unable to fetch not clocked out details.');
        } finally {
            setNotClockedOutDetailsLoading(false);
        }
    };

    const fetchTodayDevices = async () => {
        setTodayDevicesLoading(true);
        try {
            setTodayDevices(await fetchTodayDeviceCount());
        } catch (error) {
            console.error('Failed to fetch today device count:', error);
            setTodayDevices(null);
            toast.error('Unable to fetch today device count.');
        } finally {
            setTodayDevicesLoading(false);
        }
    };

    useEffect(() => {
        fetchTodayDevices();
    }, []);

    useEffect(() => {
        fetchDailyClockIns(selectedDate);
        fetchNotClockedOut();
    }, [selectedDate]);

    const tabs: Tab[] = [
        {
            title: 'District',
            route: '/district',
            activeIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M3.93547 8L31.7764 36.1176M3.93547 8C4.97133 6.77663 6.51848 6 8.24703 6H17.6588M3.93547 8C3.10235 8.98392 2.59998 10.2568 2.59998 11.6471V32.3529C2.59998 35.4717 5.12825 38 8.24703 38H28.9529C32.0717 38 34.6 35.4717 34.6 32.3529V23.8823M17.6588 23.8823L5.4235 36.1176M31 8.4V8.27969M37.4 8.26087C37.4 12.4348 31 18 31 18C31 18 24.6 12.4348 24.6 8.26087C24.6 4.80309 27.4653 2 31 2C34.5346 2 37.4 4.80309 37.4 8.26087Z" stroke="#242A30" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ),
            inactiveIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M3.93547 8L31.7764 36.1176M3.93547 8C4.97133 6.77663 6.51848 6 8.24703 6H17.6588M3.93547 8C3.10235 8.98392 2.59998 10.2568 2.59998 11.6471V32.3529C2.59998 35.4717 5.12825 38 8.24703 38H28.9529C32.0717 38 34.6 35.4717 34.6 32.3529V23.8823M17.6588 23.8823L5.4235 36.1176M31 8.4V8.27969M37.4 8.26087C37.4 12.4348 31 18 31 18C31 18 24.6 12.4348 24.6 8.26087C24.6 4.80309 27.4653 2 31 2C34.5346 2 37.4 4.80309 37.4 8.26087Z" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ),
        },
        {
            title: 'Site',
            route: '/site',
            activeIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M20 24L19.0157 25.1319C19.5801 25.6227 20.4199 25.6227 20.9843 25.1319L20 24ZM11.4098 25.2635C12.2067 25.0372 12.6693 24.2077 12.4429 23.4108C12.2166 22.6139 11.3871 22.1513 10.5902 22.3776L11.4098 25.2635ZM29.4098 22.3776C28.6129 22.1513 27.7834 22.6139 27.5571 23.4108C27.3307 24.2077 27.7933 25.0372 28.5902 25.2635L29.4098 22.3776ZM26.5 11.8261C26.5 12.7734 26.127 13.929 25.4308 15.2154C24.7455 16.4818 23.8127 17.7554 22.8494 18.9072C21.8902 20.0541 20.9267 21.0494 20.2011 21.7593C19.8392 22.1133 19.5387 22.3941 19.3305 22.5849C19.2264 22.6802 19.1456 22.7529 19.0918 22.8008C19.0649 22.8248 19.0448 22.8426 19.032 22.8539C19.0255 22.8595 19.0209 22.8635 19.0182 22.8659C19.0168 22.8671 19.016 22.8679 19.0155 22.8683C19.0153 22.8684 19.0152 22.8685 19.0153 22.8685C19.0153 22.8685 19.0154 22.8684 19.0154 22.8684C19.0156 22.8682 19.0157 22.8681 20 24C20.9843 25.1319 20.9845 25.1317 20.9848 25.1315C20.9849 25.1314 20.9852 25.1311 20.9855 25.1309C20.986 25.1304 20.9866 25.1299 20.9874 25.1292C20.9889 25.1279 20.9909 25.1261 20.9934 25.1239C20.9984 25.1196 21.0052 25.1136 21.0139 25.1059C21.0314 25.0906 21.0562 25.0686 21.0879 25.0404C21.1513 24.9839 21.2423 24.902 21.357 24.7969C21.5863 24.5868 21.9108 24.2834 22.2989 23.9038C23.0733 23.1462 24.1098 22.0764 25.1506 20.8319C26.1873 19.5924 27.2545 18.1486 28.0692 16.6433C28.873 15.158 29.5 13.4875 29.5 11.8261H26.5ZM20 24C20.9843 22.8681 20.9844 22.8682 20.9846 22.8684C20.9846 22.8684 20.9847 22.8685 20.9847 22.8685C20.9848 22.8685 20.9847 22.8684 20.9845 22.8683C20.984 22.8679 20.9832 22.8671 20.9818 22.8659C20.9791 22.8635 20.9745 22.8595 20.968 22.8539C20.9552 22.8426 20.9351 22.8248 20.9082 22.8008C20.8544 22.7529 20.7736 22.6802 20.6695 22.5849C20.4613 22.3941 20.1608 22.1133 19.7989 21.7593C19.0733 21.0494 18.1098 20.0541 17.1506 18.9072C16.1873 17.7554 15.2545 16.4818 14.5692 15.2154C13.873 13.929 13.5 12.7734 13.5 11.8261H10.5C10.5 13.4875 11.127 15.158 11.9308 16.6433C12.7455 18.1486 13.8127 19.5924 14.8494 20.8319C15.8902 22.0764 16.9267 23.1462 17.7011 23.9038C18.0892 24.2834 18.4137 24.5868 18.643 24.7969C18.7577 24.902 18.8487 24.9839 18.9121 25.0404C18.9438 25.0686 18.9686 25.0906 18.9861 25.1059C18.9948 25.1136 19.0016 25.1196 19.0066 25.1239C19.0091 25.1261 19.0111 25.1279 19.0126 25.1292C19.0134 25.1299 19.014 25.1304 19.0145 25.1309C19.0148 25.1311 19.0151 25.1314 19.0152 25.1315C19.0155 25.1317 19.0157 25.1319 20 24ZM13.5 11.8261C13.5 8.36319 16.3789 5.5 20 5.5V2.5C14.7845 2.5 10.5 6.64452 10.5 11.8261H13.5ZM20 5.5C23.6211 5.5 26.5 8.36319 26.5 11.8261H29.5C29.5 6.64452 25.2155 2.5 20 2.5V5.5ZM34.5 29.3333C34.5 29.7313 34.3128 30.2462 33.69 30.8597C33.0618 31.4785 32.076 32.1048 30.7368 32.6628C28.0649 33.7761 24.2697 34.5 20 34.5V37.5C24.5668 37.5 28.7717 36.7316 31.8906 35.432C33.4468 34.7836 34.8041 33.9733 35.7953 32.9969C36.7918 32.0153 37.5 30.7763 37.5 29.3333H34.5ZM20 34.5C15.7303 34.5 11.9351 33.7761 9.26321 32.6628C7.92399 32.1048 6.93815 31.4785 6.31003 30.8597C5.68721 30.2462 5.5 29.7313 5.5 29.3333H2.5C2.5 30.7763 3.20822 32.0153 4.20468 32.9969C5.19586 33.9733 6.55316 34.7836 8.10937 35.432C11.2283 36.7316 15.4332 37.5 20 37.5V34.5ZM5.5 29.3333C5.5 28.8423 5.79592 28.1537 6.83116 27.3557C7.85136 26.5693 9.40663 25.8324 11.4098 25.2635L10.5902 22.3776C8.36783 23.0087 6.4231 23.8825 4.99968 24.9796C3.59131 26.0652 2.5 27.533 2.5 29.3333H5.5ZM28.5902 25.2635C30.5934 25.8324 32.1486 26.5693 33.1688 27.3557C34.2041 28.1537 34.5 28.8423 34.5 29.3333H37.5C37.5 27.533 36.4087 26.0652 35.0003 24.9796C33.5769 23.8825 31.6322 23.0087 29.4098 22.3776L28.5902 25.2635Z" fill="#242A30" />
                </svg>
            ),
            inactiveIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M20 24L19.0157 25.1319C19.5801 25.6227 20.4199 25.6227 20.9843 25.1319L20 24ZM11.4098 25.2635C12.2067 25.0372 12.6693 24.2077 12.4429 23.4108C12.2166 22.6139 11.3871 22.1513 10.5902 22.3776L11.4098 25.2635ZM29.4098 22.3776C28.6129 22.1513 27.7834 22.6139 27.5571 23.4108C27.3307 24.2077 27.7933 25.0372 28.5902 25.2635L29.4098 22.3776ZM26.5 11.8261C26.5 12.7734 26.127 13.929 25.4308 15.2154C24.7455 16.4818 23.8127 17.7554 22.8494 18.9072C21.8902 20.0541 20.9267 21.0494 20.2011 21.7593C19.8392 22.1133 19.5387 22.3941 19.3305 22.5849C19.2264 22.6802 19.1456 22.7529 19.0918 22.8008C19.0649 22.8248 19.0448 22.8426 19.032 22.8539C19.0255 22.8595 19.0209 22.8635 19.0182 22.8659C19.0168 22.8671 19.016 22.8679 19.0155 22.8683C19.0153 22.8684 19.0152 22.8685 19.0153 22.8685C19.0153 22.8685 19.0154 22.8684 19.0154 22.8684C19.0156 22.8682 19.0157 22.8681 20 24C20.9843 25.1319 20.9845 25.1317 20.9848 25.1315C20.9849 25.1314 20.9852 25.1311 20.9855 25.1309C20.986 25.1304 20.9866 25.1299 20.9874 25.1292C20.9889 25.1279 20.9909 25.1261 20.9934 25.1239C20.9984 25.1196 21.0052 25.1136 21.0139 25.1059C21.0314 25.0906 21.0562 25.0686 21.0879 25.0404C21.1513 24.9839 21.2423 24.902 21.357 24.7969C21.5863 24.5868 21.9108 24.2834 22.2989 23.9038C23.0733 23.1462 24.1098 22.0764 25.1506 20.8319C26.1873 19.5924 27.2545 18.1486 28.0692 16.6433C28.873 15.158 29.5 13.4875 29.5 11.8261H26.5ZM20 24C20.9843 22.8681 20.9844 22.8682 20.9846 22.8684C20.9846 22.8684 20.9847 22.8685 20.9847 22.8685C20.9848 22.8685 20.9847 22.8684 20.9845 22.8683C20.984 22.8679 20.9832 22.8671 20.9818 22.8659C20.9791 22.8635 20.9745 22.8595 20.968 22.8539C20.9552 22.8426 20.9351 22.8248 20.9082 22.8008C20.8544 22.7529 20.7736 22.6802 20.6695 22.5849C20.4613 22.3941 20.1608 22.1133 19.7989 21.7593C19.0733 21.0494 18.1098 20.0541 17.1506 18.9072C16.1873 17.7554 15.2545 16.4818 14.5692 15.2154C13.873 13.929 13.5 12.7734 13.5 11.8261H10.5C10.5 13.4875 11.127 15.158 11.9308 16.6433C12.7455 18.1486 13.8127 19.5924 14.8494 20.8319C15.8902 22.0764 16.9267 23.1462 17.7011 23.9038C18.0892 24.2834 18.4137 24.5868 18.643 24.7969C18.7577 24.902 18.8487 24.9839 18.9121 25.0404C18.9438 25.0686 18.9686 25.0906 18.9861 25.1059C18.9948 25.1136 19.0016 25.1196 19.0066 25.1239C19.0091 25.1261 19.0111 25.1279 19.0126 25.1292C19.0134 25.1299 19.014 25.1304 19.0145 25.1309C19.0148 25.1311 19.0151 25.1314 19.0152 25.1315C19.0155 25.1317 19.0157 25.1319 20 24ZM13.5 11.8261C13.5 8.36319 16.3789 5.5 20 5.5V2.5C14.7845 2.5 10.5 6.64452 10.5 11.8261H13.5ZM20 5.5C23.6211 5.5 26.5 8.36319 26.5 11.8261H29.5C29.5 6.64452 25.2155 2.5 20 2.5V5.5ZM34.5 29.3333C34.5 29.7313 34.3128 30.2462 33.69 30.8597C33.0618 31.4785 32.076 32.1048 30.7368 32.6628C28.0649 33.7761 24.2697 34.5 20 34.5V37.5C24.5668 37.5 28.7717 36.7316 31.8906 35.432C33.4468 34.7836 34.8041 33.9733 35.7953 32.9969C36.7918 32.0153 37.5 30.7763 37.5 29.3333H34.5ZM20 34.5C15.7303 34.5 11.9351 33.7761 9.26321 32.6628C7.92399 32.1048 6.93815 31.4785 6.31003 30.8597C5.68721 30.2462 5.5 29.7313 5.5 29.3333H2.5C2.5 30.7763 3.20822 32.0153 4.20468 32.9969C5.19586 33.9733 6.55316 34.7836 8.10937 35.432C11.2283 36.7316 15.4332 37.5 20 37.5V34.5ZM5.5 29.3333C5.5 28.8423 5.79592 28.1537 6.83116 27.3557C7.85136 26.5693 9.40663 25.8324 11.4098 25.2635L10.5902 22.3776C8.36783 23.0087 6.4231 23.8825 4.99968 24.9796C3.59131 26.0652 2.5 27.533 2.5 29.3333H5.5ZM28.5902 25.2635C30.5934 25.8324 32.1486 26.5693 33.1688 27.3557C34.2041 28.1537 34.5 28.8423 34.5 29.3333H37.5C37.5 27.533 36.4087 26.0652 35.0003 24.9796C33.5769 23.8825 31.6322 23.0087 29.4098 22.3776L28.5902 25.2635Z" fill="white" />
                </svg>
            ),
        },
        {
            title: 'Personnel',
            route: '/personnel',
            activeIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M32 22.8095C34.1122 24.3877 36 28.3611 36 30.8094C36 31.5721 35.4435 32.1905 34.757 32.1905H34M26 16.3408C27.3664 15.5504 28.2857 14.073 28.2857 12.3809C28.2857 10.6889 27.3664 9.21151 26 8.42109M5.24295 32.1905H27.138C27.8245 32.1905 28.3809 31.5721 28.3809 30.8094C28.3809 26.0151 24.3755 22.1285 16.1905 22.1285C8.00544 22.1285 4 26.0151 4 30.8094C4 31.5721 4.55649 32.1905 5.24295 32.1905ZM20.7619 12.3809C20.7619 14.9057 18.7152 16.9524 16.1905 16.9524C13.6657 16.9524 11.619 14.9057 11.619 12.3809C11.619 9.85621 13.6657 7.80951 16.1905 7.80951C18.7152 7.80951 20.7619 9.85621 20.7619 12.3809Z" stroke="#242A30" stroke-width="3" stroke-linecap="round" />
                </svg>
            ),
            inactiveIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M32 22.8095C34.1122 24.3877 36 28.3611 36 30.8094C36 31.5721 35.4435 32.1905 34.757 32.1905H34M26 16.3408C27.3664 15.5504 28.2857 14.073 28.2857 12.3809C28.2857 10.6889 27.3664 9.21151 26 8.42109M5.24295 32.1905H27.138C27.8245 32.1905 28.3809 31.5721 28.3809 30.8094C28.3809 26.0151 24.3755 22.1285 16.1905 22.1285C8.00544 22.1285 4 26.0151 4 30.8094C4 31.5721 4.55649 32.1905 5.24295 32.1905ZM20.7619 12.3809C20.7619 14.9057 18.7152 16.9524 16.1905 16.9524C13.6657 16.9524 11.619 14.9057 11.619 12.3809C11.619 9.85621 13.6657 7.80951 16.1905 7.80951C18.7152 7.80951 20.7619 9.85621 20.7619 12.3809Z" stroke="white" stroke-width="3" stroke-linecap="round" />
                </svg>
            ),
        },
        {
            title: 'School',
            route: '/school',
            activeIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <g clip-path="url(#clip0_852_4630)">
                        <path d="M20 5L1.66663 15L8.33329 18.6333V28.6333L20 35L31.6666 28.6333V18.6333L35 16.8167V28.3333H38.3333V15L20 5ZM31.3666 15L20 21.2L8.63329 15L20 8.8L31.3666 15ZM28.3333 26.65L20 31.2L11.6666 26.65V20.45L20 25L28.3333 20.45V26.65Z" fill="#242A30" />
                    </g>
                    <defs>
                        <clipPath id="clip0_852_4630">
                            <rect width="40" height="40" fill="#242A30" />
                        </clipPath>
                    </defs>
                </svg>
            ),
            inactiveIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <g clip-path="url(#clip0_852_4630)">
                        <path d="M20 5L1.66663 15L8.33329 18.6333V28.6333L20 35L31.6666 28.6333V18.6333L35 16.8167V28.3333H38.3333V15L20 5ZM31.3666 15L20 21.2L8.63329 15L20 8.8L31.3666 15ZM28.3333 26.65L20 31.2L11.6666 26.65V20.45L20 25L28.3333 20.45V26.65Z" fill="white" />
                    </g>
                    <defs>
                        <clipPath id="clip0_852_4630">
                            <rect width="40" height="40" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            ),
        },
        {
            title: 'Inservice',
            route: '/inservice',
            activeIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M13 32V14M26 32V14M14 13V9C14 7.89543 14.8954 7 16 7H23C24.1046 7 25 7.89543 25 9V13M8 33H32C34.2091 33 36 31.2091 36 29V17C36 14.7909 34.2091 13 32 13H8C5.79086 13 4 14.7909 4 17V29C4 31.2091 5.79086 33 8 33Z" stroke="#242A30" stroke-width="3" stroke-linecap="round" />
                </svg>
            ),
            inactiveIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M13 32V14M26 32V14M14 13V9C14 7.89543 14.8954 7 16 7H23C24.1046 7 25 7.89543 25 9V13M8 33H32C34.2091 33 36 31.2091 36 29V17C36 14.7909 34.2091 13 32 13H8C5.79086 13 4 14.7909 4 17V29C4 31.2091 5.79086 33 8 33Z" stroke="white" stroke-width="3" stroke-linecap="round" />
                </svg>
            ),
        },
        {
            title: 'Visits',
            route: '/visits',
            activeIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M20 28.3333V15V5L29 12L21 18M14 22.1513C8.13634 23.1402 4 25.5355 4 28.3333C4 32.0152 11.1634 35 20 35C28.8366 35 36 32.0152 36 28.3333C36 25.5355 31.8637 23.1402 26 22.1513" stroke="#242A30" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ),
            inactiveIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M20 28.3333V15V5L29 12L21 18M14 22.1513C8.13634 23.1402 4 25.5355 4 28.3333C4 32.0152 11.1634 35 20 35C28.8366 35 36 32.0152 36 28.3333C36 25.5355 31.8637 23.1402 26 22.1513" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ),
        },
        {
            title: 'Closing',
            route: '/closing',
            activeIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M20 21.618V13.5541M20 27.5951V27.666M30.0799 34.382H9.92012C7.16641 34.382 4.84253 32.5416 4.11138 30.0237C3.79927 28.9489 4.18277 27.8294 4.76935 26.8762L14.8492 8.49628C17.2108 4.65863 22.7892 4.65863 25.1508 8.49628L35.2306 26.8762C35.8172 27.8294 36.2007 28.9489 35.8886 30.0237C35.1575 32.5416 32.8336 34.382 30.0799 34.382Z" stroke="#242A30" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ),
            inactiveIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M20 21.618V13.5541M20 27.5951V27.666M30.0799 34.382H9.92012C7.16641 34.382 4.84253 32.5416 4.11138 30.0237C3.79927 28.9489 4.18277 27.8294 4.76935 26.8762L14.8492 8.49628C17.2108 4.65863 22.7892 4.65863 25.1508 8.49628L35.2306 26.8762C35.8172 27.8294 36.2007 28.9489 35.8886 30.0237C35.1575 32.5416 32.8336 34.382 30.0799 34.382Z" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ),
        },
        {
            title: 'Contacts',
            route: '/contact',
            activeIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M9 32C9.76862 31.1392 13.3684 27.1778 14.4233 27.1778H25.5773C27.106 27.1778 30.2266 30.4615 31 31.619M36 20C36 28.8365 28.8365 36 20 36C11.1634 36 4 28.8365 4 20C4 11.1634 11.1634 4 20 4C28.8365 4 36 11.1634 36 20ZM25.7314 14.5466C25.7314 11.4941 23.1545 9 20.0005 9C16.8465 9 14.2696 11.4941 14.2696 14.5466C14.2696 17.5991 16.8465 20.0932 20.0005 20.0932C23.1544 20.0932 25.7314 17.5991 25.7314 14.5466Z" stroke="#242A30" stroke-width="3" />
                </svg>

            ),
            inactiveIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M9 32C9.76862 31.1392 13.3684 27.1778 14.4233 27.1778H25.5773C27.106 27.1778 30.2266 30.4615 31 31.619M36 20C36 28.8365 28.8365 36 20 36C11.1634 36 4 28.8365 4 20C4 11.1634 11.1634 4 20 4C28.8365 4 36 11.1634 36 20ZM25.7314 14.5466C25.7314 11.4941 23.1545 9 20.0005 9C16.8465 9 14.2696 11.4941 14.2696 14.5466C14.2696 17.5991 16.8465 20.0932 20.0005 20.0932C23.1544 20.0932 25.7314 17.5991 25.7314 14.5466Z" stroke="white" stroke-width="3" />
                </svg>
            ),
        },
        {
            title: 'Report',
            route: '/report',
            activeIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M19.2003 10.4V15.2C19.2003 16.0837 19.9167 16.8 20.8003 16.8H25.6003M28.8003 4H17.5999C15.8326 4 14.3999 5.43268 14.3999 7.19998V10.4M28.8003 4H29.6929C30.1435 4 30.5724 4.18978 30.8828 4.51637C31.3493 5.00717 32.0882 5.76286 32.8003 6.4C33.3584 6.89936 34.2352 7.79553 34.7603 8.34018C35.0442 8.63471 35.2003 9.02799 35.2003 9.43711L35.2003 10.4M28.8003 4V8.8C28.8003 9.68366 29.5167 10.4 30.4003 10.4H35.2003M35.2003 10.4L35.1999 26.4001C35.1998 28.1674 33.7671 29.6 31.9999 29.6H25.5998M23.2003 12.8C22.4882 12.1629 21.7493 11.4072 21.2828 10.9164C20.9724 10.5898 20.5435 10.4 20.0929 10.4H7.99993C6.23263 10.4 4.79994 11.8327 4.79993 13.6L4.7998 32.7999C4.79979 34.5672 6.23248 35.9999 7.99979 35.9999L22.3999 36C24.1671 36 25.5998 34.5674 25.5999 32.8001L25.6003 15.8371C25.6003 15.428 25.4442 15.0347 25.1603 14.7402C24.6352 14.1955 23.7584 13.2994 23.2003 12.8Z" stroke="#242A30" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ),
            inactiveIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M19.2003 10.4V15.2C19.2003 16.0837 19.9167 16.8 20.8003 16.8H25.6003M28.8003 4H17.5999C15.8326 4 14.3999 5.43268 14.3999 7.19998V10.4M28.8003 4H29.6929C30.1435 4 30.5724 4.18978 30.8828 4.51637C31.3493 5.00717 32.0882 5.76286 32.8003 6.4C33.3584 6.89936 34.2352 7.79553 34.7603 8.34018C35.0442 8.63471 35.2003 9.02799 35.2003 9.43711L35.2003 10.4M28.8003 4V8.8C28.8003 9.68366 29.5167 10.4 30.4003 10.4H35.2003M35.2003 10.4L35.1999 26.4001C35.1998 28.1674 33.7671 29.6 31.9999 29.6H25.5998M23.2003 12.8C22.4882 12.1629 21.7493 11.4072 21.2828 10.9164C20.9724 10.5898 20.5435 10.4 20.0929 10.4H7.99993C6.23263 10.4 4.79994 11.8327 4.79993 13.6L4.7998 32.7999C4.79979 34.5672 6.23248 35.9999 7.99979 35.9999L22.3999 36C24.1671 36 25.5998 34.5674 25.5999 32.8001L25.6003 15.8371C25.6003 15.428 25.4442 15.0347 25.1603 14.7402C24.6352 14.1955 23.7584 13.2994 23.2003 12.8Z" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ),

        },
        {
            title: 'BulkTimeSheet',
            route: '/bulkTimeSheet',
            activeIcon: (
                <svg viewBox="0 0 23 23" width="40" height="40" id="meteor-icon-kit__regular-bulk-edit" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 18H8C6.34315 18 5 16.6569 5 15V13H3C1.34315 13 0 11.6569 0 10V3C0 1.34315 1.34315 0 3 0H10C11.6569 0 13 1.34315 13 3V5H15C16.6569 5 18 6.34315 18 8V10H20C21.6569 10 23 11.3431 23 13V20C23 21.6569 21.6569 23 20 23H13C11.3431 23 10 21.6569 10 20V18ZM10 16V13C10 11.3431 11.3431 10 13 10H16V8C16 7.44772 15.5523 7 15 7H8C7.44772 7 7 7.44772 7 8V15C7 15.5523 7.44772 16 8 16H10ZM5 11V8C5 6.34315 6.34315 5 8 5H11V3C11 2.44772 10.5523 2 10 2H3C2.44772 2 2 2.44772 2 3V10C2 10.5523 2.44772 11 3 11H5ZM13 12C12.4477 12 12 12.4477 12 13V20C12 20.5523 12.4477 21 13 21H20C20.5523 21 21 20.5523 21 20V13C21 12.4477 20.5523 12 20 12H13Z" fill="#242A30"></path></g></svg>
            ),
            inactiveIcon: (
                
                <svg viewBox="0 0 23 23" width="40" height="40" id="meteor-icon-kit__regular-bulk-edit" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 18H8C6.34315 18 5 16.6569 5 15V13H3C1.34315 13 0 11.6569 0 10V3C0 1.34315 1.34315 0 3 0H10C11.6569 0 13 1.34315 13 3V5H15C16.6569 5 18 6.34315 18 8V10H20C21.6569 10 23 11.3431 23 13V20C23 21.6569 21.6569 23 20 23H13C11.3431 23 10 21.6569 10 20V18ZM10 16V13C10 11.3431 11.3431 10 13 10H16V8C16 7.44772 15.5523 7 15 7H8C7.44772 7 7 7.44772 7 8V15C7 15.5523 7.44772 16 8 16H10ZM5 11V8C5 6.34315 6.34315 5 8 5H11V3C11 2.44772 10.5523 2 10 2H3C2.44772 2 2 2.44772 2 3V10C2 10.5523 2.44772 11 3 11H5ZM13 12C12.4477 12 12 12.4477 12 13V20C12 20.5523 12.4477 21 13 21H20C20.5523 21 21 20.5523 21 20V13C21 12.4477 20.5523 12 20 12H13Z" fill="#fff"></path></g></svg>
            ),

        },
        {
            title: 'Status',
            route: '/status',
            activeIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <g opacity="0.9">
                        <path d="M30 20C30 25.1858 26.0526 29.4497 20.9986 29.9508C20.449 30.0053 20 29.5523 20 29V11C20 10.4477 20.449 9.99475 20.9986 10.0492C26.0526 10.5503 30 14.8142 30 20Z" stroke="#242A30" stroke-width="3" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M36 20C36 28.8366 28.8366 36 20 36C11.1634 36 4 28.8366 4 20C4 11.1634 11.1634 4 20 4C28.8366 4 36 11.1634 36 20Z" stroke="#242A30" stroke-width="3" />
                    </g>
                </svg>
            ),
            inactiveIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <g opacity="0.9">
                        <path d="M30 20C30 25.1858 26.0526 29.4497 20.9986 29.9508C20.449 30.0053 20 29.5523 20 29V11C20 10.4477 20.449 9.99475 20.9986 10.0492C26.0526 10.5503 30 14.8142 30 20Z" stroke="white" stroke-width="3" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M36 20C36 28.8366 28.8366 36 20 36C11.1634 36 4 28.8366 4 20C4 11.1634 11.1634 4 20 4C28.8366 4 36 11.1634 36 20Z" stroke="white" stroke-width="3" />
                    </g>
                </svg>
            ),
        },
        {
            title: 'Workshop',
            route: '/workshop',
            activeIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M12 19V17M20 19V15M28 19V11M16 27L13 35M27.656 34.8889L24.1205 27.1107M8 27C5.79086 27 4 25.2091 4 23V9C4 6.79086 5.79086 5 8 5H32C34.2091 5 36 6.79086 36 9V23C36 25.2091 34.2091 27 32 27H8Z" stroke="#242A30" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ),
            inactiveIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M12 19V17M20 19V15M28 19V11M16 27L13 35M27.656 34.8889L24.1205 27.1107M8 27C5.79086 27 4 25.2091 4 23V9C4 6.79086 5.79086 5 8 5H32C34.2091 5 36 6.79086 36 9V23C36 25.2091 34.2091 27 32 27H8Z" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ),
        },
        {
            title: "",
            route: 'daily-clockins',
            activeIcon: (
                <div className="text-start">
                    <div className="display-4 fw-bold text-primary">
                        {dailyClockInsLoading ? '...' : dailyClockIns !== null ? dailyClockIns : '--'}
                    </div>
                    <div className="small text-primary fw-semibold">
                        employees<br />clocked in today
                    </div>
                </div>
            ),
            inactiveIcon: (
                <div className="text-start">
                    <div className="display-4 fw-bold text-white">
                        {dailyClockInsLoading ? '...' : dailyClockIns !== null ? dailyClockIns : '--'}
                    </div>
                    <div className="small text-white fw-semibold">
                        employees<br />clocked in today
                    </div>
                </div>
            ),
        },
        {
            title: "",
            route: 'not-clocked-out',
            activeIcon: (
                <div className="text-start">
                    <div className="display-4 fw-bold text-primary">
                        {notClockedOutLoading ? '...' : notClockedOut !== null ? notClockedOut : '--'}
                    </div>
                    <div className="small text-primary fw-semibold">
                        employees<br />not clocked out
                    </div>
                </div>
            ),
            inactiveIcon: (
                <div className="text-start">
                    <div className="display-4 fw-bold text-white">
                        {notClockedOutLoading ? '...' : notClockedOut !== null ? notClockedOut : '--'}
                    </div>
                    <div className="small text-white fw-semibold">
                        employees<br />not clocked out
                    </div>
                </div>
            ),
        },
        {
            title: "",
            route: 'today-devices',
            activeIcon: (
                <div className="text-start">
                    <div className="display-4 fw-bold text-primary">
                        {todayDevicesLoading ? '...' : todayDevices !== null ? todayDevices : '--'}
                    </div>
                    <div className="small text-primary fw-semibold">
                        devices<br />online today
                    </div>
                </div>
            ),
            inactiveIcon: (
                <div className="text-start">
                    <div className="display-4 fw-bold text-white">
                        {todayDevicesLoading ? '...' : todayDevices !== null ? todayDevices : '--'}
                    </div>
                    <div className="small text-white fw-semibold">
                        devices<br />online today
                    </div>
                </div>
            ),
        },
    ];


    const exportToExcel = (data: any[]) => {
        if (data.length === 0) {
            toast.error('No data to export');
            return;
        }

        // Create CSV content
        const headers = ['First Name', 'Last Name', 'Site', 'Clock In', 'Clock Out'];
        const csvContent = [
            headers.join(','),
            ...data.map(item => [
                item.firstName || 'N/A',
                item.lastName || 'N/A', 
                item.siteName || 'N/A',
                item.clockIn || 'N/A',
                item.clockOut || 'Not clocked out'
            ].map(field => `"${field}"`).join(','))
        ].join('\n');

        // Create and download file
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `not_clocked_out_employees_${new Date().toISOString().split('T')[0]}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        
        toast.success('Data exported successfully');
    };

    return (
        <>
            <section className='dashboardMain'>
                <header className='dashboardMainHeader pb-lg-0 mb-4'>
                    <div className='container'>
                        <div className='row'>
                            <div className="col-xl-6 col-lg-6 col-md-3 col-sm-4 col-4 d-flex align-items-center">
                                <div className="pageTitle">
                                    <img src={logoWhite} />
                                </div>
                            </div>
                            <div
                                className="col-lg-6 col-md-6 col-sm-8 col-8 d-flex align-items-center justify-content-end gap-lg-4 gap-md-3 gap-sm-3 gap-3">
                                <div className="d-lg-none d-md-none d-block">
                                    <svg viewBox="0 0 24 24" width="30px" height="30px" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round">
                                        </g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path d="M4 7L7 7M20 7L11 7" stroke="#1C274C" stroke-width="1.5"
                                                stroke-linecap="round"></path>
                                            <path d="M20 17H17M4 17L13 17" stroke="#1C274C" stroke-width="1.5"
                                                stroke-linecap="round"></path>
                                            <path d="M4 12H7L20 12" stroke="#1C274C" stroke-width="1.5"
                                                stroke-linecap="round"></path>
                                        </g>
                                    </svg>
                                </div>
                                <div className="headerUser d-flex align-items-center gap-3">
                                    <img src={userImg} alt="" />
                                    <h4 className="d-lg-block d-md-block d-sm-block d-none text-white">{userData ? (
                                        <span> {userData.firstName}</span>
                                    ) : (
                                        ''
                                    )}</h4>
                                </div>
                                <div className="logOut" style={{ cursor: 'pointer' }} onClick={handleLogout}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"
                                        fill="none">
                                        <path
                                            d="M14.6471 8.3001V6.2001C14.6471 5.64314 14.424 5.109 14.0268 4.71517C13.6297 4.32135 13.091 4.1001 12.5294 4.1001H5.11765C4.55601 4.1001 4.01738 4.32135 3.62024 4.71517C3.22311 5.109 3 5.64314 3 6.2001V18.8001C3 19.3571 3.22311 19.8912 3.62024 20.285C4.01738 20.6788 4.55601 20.9001 5.11765 20.9001H12.5294C13.091 20.9001 13.6297 20.6788 14.0268 20.285C14.424 19.8912 14.6471 19.3571 14.6471 18.8001V16.7001M8.29412 12.5001H21M21 12.5001L17.8235 9.3501M21 12.5001L17.8235 15.6501"
                                            stroke="#fff" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                {/* <div className='container mb-4'>
                    <div className='row align-items-center'>
                        <div className='col-md-6 mb-3'>
                            <div className='border rounded p-3 bg-white h-100'>
                                <h6 className='mb-2'>Daily clock-ins (unique users)</h6>
                                <div className='display-6'>
                                    {dailyClockInsLoading ? 'Loading...' : dailyClockIns !== null ? dailyClockIns : '--'}
                                </div>
                                <small className='text-muted'>Timezone: app local time</small>
                                <button
                                    className='btn btn-primary btn-sm mt-2'
                                    onClick={() => fetchDailyClockInsDetails()}
                                    disabled={detailsLoading}
                                >
                                    {detailsLoading ? 'Loading...' : 'View Details'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className='container pt-lg-0 pt-md-0'>                   
                    <div className='row g-lg-4 g-md-4 g-4'>
                        <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                            <div className='dashboardTbasCard'>
                                <div className='row g-4'>
                                    {tabs.map((tab) => (
                                        <div key={tab.route} className='col-xl-4 col-lg-4 col-md-3 col-sm-4 col-12' style={{ cursor: 'pointer' }}>
                                            <a onClick={() => handleNavigation(tab.route)}>
                                                <div className='tabsUi text-center'>
                                                    <div className='inactive'>
                                                        {tab.inactiveIcon}
                                                    </div>
                                                    <div className='active'>
                                                        {tab.activeIcon}
                                                    </div>
                                                    <h6 className={`mb-0 ${typeof tab.title === 'string' && tab.title.trim().length > 0 ? 'mt-4' : 'mt-2'}`}>{tab.title}</h6>
                                                </div>
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-7 dashMap col-md-12 col-sm-12 col-12 d-flex align-items-end'>
                                <Map />
                        </div>
                    </div>
                </div>
            </section>
            {showDetailsModal && (
                <div className="modal fade show d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-xl modal-dialog-centered">
                        <div className="modal-content shadow-lg">
                            <div className="modal-header border-bottom">
                                <h5 className="modal-title fw-bold">Daily Clock-in Details</h5>
                                <button type="button" className="btn-close" onClick={() => setShowDetailsModal(false)}></button>
                            </div>
                            <div className="modal-body p-4">
                                {detailsLoading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-secondary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="mt-3 text-muted">Fetching clock-in details...</p>
                                    </div>
                                ) : (
                                    <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                        <table className="table table-hover">
                                            <thead className="bg-light sticky-top">
                                                <tr>
                                                    <th className="text-center">Staff ID</th>
                                                    <th className="text-center">Name</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dailyClockInsList.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="text-center">{item.staffId || 'N/A'}</td>
                                                        <td className="text-center">{item.fullName || 'N/A'}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        {dailyClockInsList.length === 0 && (
                                            <p className="text-center text-muted mt-3">No additional clock-ins found.</p>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showNotClockedOutModal && (
                <div className="modal fade show d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-xl modal-dialog-centered">
                        <div className="modal-content shadow-lg">
                            <div className="modal-header border-bottom">
                                <h5 className="modal-title fw-bold">Employees Not Clocked Out</h5>
                                <button type="button" className="btn-close" onClick={() => setShowNotClockedOutModal(false)}></button>
                            </div>
                            <div className="modal-body p-4">
                                {notClockedOutDetailsLoading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-secondary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="mt-3 text-muted">Fetching employee details...</p>
                                    </div>
                                ) : (
                                    <>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h6 className="mb-0">Employees who haven't clocked out</h6>
                                            <button 
                                                className="btn btn-success btn-sm"
                                                onClick={() => exportToExcel(notClockedOutList)}
                                                disabled={notClockedOutList.length === 0}
                                            >
                                                Export to Excel
                                            </button>
                                        </div>
                                        <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                            <table className="table table-hover">
                                                <thead className="bg-light sticky-top">
                                                    <tr>
                                                        <th className="text-center">First Name</th>
                                                        <th className="text-center">Last Name</th>
                                                        <th className="text-center">Site</th>
                                                        <th className="text-center">Clock In</th>
                                                        <th className="text-center">Clock Out</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {notClockedOutList.map((item, index) => (
                                                        <tr key={index}>
                                                            <td className="text-center">{item.firstName || 'N/A'}</td>
                                                            <td className="text-center">{item.lastName || 'N/A'}</td>
                                                            <td className="text-center">{item.siteName || 'N/A'}</td>
                                                            <td className="text-center">{item.clockIn || 'N/A'}</td>
                                                            <td className="text-center text-danger">{item.clockOut || 'Not clocked out'}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            {notClockedOutList.length === 0 && (
                                                <p className="text-center text-muted mt-3">No employees found who haven't clocked out.</p>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default memo(Dashboard);